import request from '@/utils/request';

export function getcourse(id) {
  return request({
    url: '/user/v1/course/' + id,
    method: 'get',
  })
}

export function getcourseFile(data) {
  return request({
    url: '/user/v1/coursefile',
    method: 'get',
    params: data
  })
}
export function getcourseFileNew(data) {
  return request({
    url: '/user/v1/coursefilenew',
    method: 'get',
    params: data
  })
}

export function getcourseclass(id) {
  return request({
    url: '/user/v1/courseclass/' + id,
    method: 'get',
  })
}

export function submitpaper(id, data) {
  return request({
    url: '/user/v1/paper/' + id,
    method: 'put',
    data: data
  })
}

export function getcomment(data) {
  return request({
    url: '/user/v1/comment',
    method: 'get',
    params: data,
  })
}

export function addcomment(data) {
  return request({
    url: '/user/v1/comment',
    method: 'post',
    data: data,
  })
}

export function changelearnprocess(id,data) {
  return request({
    url: '/user/v1/learnprocess/' + id,
    method: 'put',
    data: data,
  })
}



// WEBPACK FOOTER //
// ./src/api/learnspace.js